export default __webpack_public_path__ + "static/media/slide1_bg.4cc4222e.jpg";